<template>
  <button class="btn btn-info" @click.prevent="add()">
    <i class="fa fa-fw fa-plus"></i>
    <slot>Dodaj wiersz</slot>
  </button>
</template>

<script>
export default {
  name: 'w-add-row',
  props: {
    model: {
      type: Object,
      required: true
    },
    count: {
      type: Number,
      default: 1
    },
    rowDefault: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  methods: {
    add() {
      this.model.$addRow({...this.rowDefault}, this.count);
      this.$emit('rowAdded', this.count);
    }
  }
};
</script>
